export default "__VITE_ASSET__4db7d12b__"